export default "__VITE_ASSET__DcpPPfTR__"